<template>
    <div v-if="user" class="contact-section d-flex flex-row flex-sm-column justify-center justify-sm-end align-center align-sm-end ga-2">
        <div v-if="user.email" class="d-flex align-center">
            <v-btn
                icon
                size="x-large"
                elevation="3"
                color="white"
                density="compact"
                :href="`mailto:${user.email}`"
            >
                <v-icon>mdi-email-outline</v-icon>
                <v-tooltip location="left" activator="parent">
                    {{ user.email }}
                </v-tooltip>
            </v-btn>
        </div>
        <div v-if="formattedPhone" class="d-flex align-center">
            <v-btn
                icon
                size="x-large"
                elevation="3"
                color="white"
                density="compact"
                :href="`tel:${formattedPhone}`"
            >
                <v-icon>mdi-phone-outline</v-icon>
                <v-tooltip location="left" activator="parent">
                    {{ formattedPhone }}
                </v-tooltip>
            </v-btn>
        </div>
        <div v-if="user.phone && user.hasWhatsApp" class="d-flex align-center">
            <MessagingButton
                :uid="`contact-wa-${user.id}`"
                :form-type="formType"
                :user-has-app="!!user.hasWhatsApp"
                :phone="formattedPhone"
                color="white"
                icon-color="green"
                icon="mdi-whatsapp"
                icon-type="mdi"
                :tooltip-text="$t('entries.infoMessageWhatsapp')"
                :primary-action="(phone) => openWhatsApp(phone)"
                :secondary-action="openWhatsAppDownload"
                :secondary-action-label="$t('entries.downloadWhatsapp')"
            />
        </div>
        <div v-if="user.phone && user.hasSignalApp" class="d-flex align-center">
            <MessagingButton
                :uid="`contact-sig-${user.id}`"
                :form-type="formType"
                :user-has-app="!!user.hasSignalApp"
                :phone="formattedPhone"
                color="white"
                icon-color="blue"
                :icon="signalIcon"
                icon-type="img"
                :tooltip-text="$t('entries.infoMessageSignal')"
                :primary-action="(phone) => openSignal(phone)"
                :secondary-action="openSignalDownload"
                :secondary-action-label="$t('entries.downloadSignal')"
            />
        </div>
    </div>
</template>

<script>
import MessagingButton from "@/components/MessagingButton.vue";
import signalIcon from "@/assets/signal.svg";
import {
    openSignalChat,
    openSignalDownloadPage,
    openWhatsAppChat,
    openWhatsAppDownloadPage,
} from "@/utils/messagingContact";

export default {
    name: "ContactSection",
    components: { MessagingButton },
    props: {
        user: {
            type: Object,
            default: null,
        },
        formType: {
            type: String,
            default: "truck",
        },
        prefillMessage: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            signalIcon,
        };
    },
    computed: {
        formattedPhone() {
            const u = this.user;
            if (!u?.phone) return "";
            const prefix = (u.phone_prefix || "").trim();
            const phone = (u.phone || "").trim();
            if (!prefix) {
                return phone.startsWith("+") ? phone : `+${phone}`;
            }
            const cleanPrefix = prefix.startsWith("+") ? prefix : `+${prefix}`;
            const cleanPhone = phone.replace(/^\+/, "");
            return `${cleanPrefix}${cleanPhone}`;
        },
    },
    methods: {
        openWhatsApp(phone) {
            openWhatsAppChat(phone, this.prefillMessage);
        },
        openWhatsAppDownload() {
            openWhatsAppDownloadPage();
        },
        openSignal(phone) {
            openSignalChat(phone);
        },
        openSignalDownload() {
            openSignalDownloadPage();
        },
    },
};
</script>

<style scoped>
.contact-section {
    min-width: 0;
}
</style>
